import { Box, Typography } from '@mui/material';
import { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';

import { scrollToAnchor } from 'shared/ui/MarkdownDisplay/ui/MarkdownUtils';
import { OrderApiKeys } from 'shared/ui/OrderApiKeys';
import { SellerApiConfigForm } from 'shared/ui/SellerApiConfigForm';
import { SellerIntegrationSettingsForm } from 'shared/ui/SellerIntegrationSettingsForm';

export const IntegrationConfigPage = memo(() => {
  const { t } = useTranslation();
  const { sellerId } = useParams();
  const location = useLocation();

  useEffect(() => {
    requestAnimationFrame(() => {
      scrollToAnchor();
    });
  }, [location.hash]);

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Typography component="h2" typography="openSans.h2" id="re-ops-api">
        {t('RE-OPS API access')}
      </Typography>
      <Box marginBottom="20px">
        <OrderApiKeys sellerId={sellerId} />
      </Box>

      <a id="seller-api-config"></a>
      <SellerApiConfigForm title={t('Seller API')} sellerId={sellerId} />

      <a id="seller-api-settings"></a>
      <SellerIntegrationSettingsForm
        sellerId={sellerId}
        title={t('Integration Settings')}
      />
    </Box>
  );
});
